import _get from 'lodash/get';
import _isFinite from 'lodash/isFinite';
import { createSelector } from 'reselect';
import {
  CURRENT_ASSETS_KEY,
  CURRENT_LIABILITIES_KEY,
  FACT_CALCULATIONS_KEY,
  REPORTED_EBITDA_KEY,
  REPORTED_REVENUE_KEY,
} from '../utilities/constants';
import { getTimePeriodsForNwC } from './timePeriodSelectors';

export const getReportedRevenue = (state) =>
  _get(state, `${FACT_CALCULATIONS_KEY}.${REPORTED_REVENUE_KEY}`, {});

export const getReportedEbitda = (state) =>
  _get(state, `${FACT_CALCULATIONS_KEY}.${REPORTED_EBITDA_KEY}`, {});

export const getCurrentAssets = (state) =>
  _get(state, `${FACT_CALCULATIONS_KEY}.${CURRENT_ASSETS_KEY}`, {});

export const getCurrentLiabilities = (state) =>
  _get(state, `${FACT_CALCULATIONS_KEY}.${CURRENT_LIABILITIES_KEY}`, {});

export const getReportedWorkingCapital = createSelector(
  getTimePeriodsForNwC,
  getCurrentAssets,
  getCurrentLiabilities,
  (timePeriods, assets, liabilities) => {
    return timePeriods.reduce((acc, currentTimePeriod) => {
      const asset = assets[currentTimePeriod];
      const liability = liabilities[currentTimePeriod];
      const workingCapital = parseFloat(asset) + parseFloat(liability);
      const sanitizedWorkingCapital = _isFinite(workingCapital)
        ? workingCapital
        : undefined;
      return { ...acc, [currentTimePeriod]: sanitizedWorkingCapital };
    }, {});
  }
);
